// Show shipping button just for a collection
var showShipping = false;
var mandatory = false;
function disableCheckoutButton(){    
    console.log('disable')
    $('[name=checkout]').attr('disabled', 'disabled');
    //$('[name=chekout]').attr('disabled', 'disabled');
  }

var excluded = false;
var notExcluded = false;
$('.critem').each(function(){
  var itemCollections = $(this).data('collections');
  var itemTitle = $(this).data('title');
  if (itemTitle === 'Pickup Instore') return;
  console.log({itemTitle})  
  console.log('-->', itemCollections)
  if (itemCollections.indexOf('Click & Collect') > -1) {
  	excluded = true
  } else {
  	notExcluded = true;
  }
  
  
})
console.log({excluded, notExcluded})
// Remove the pickup option
if (notExcluded === true) { 
    $('#pickup-container').remove();
}

document.addEventListener('crJQActivated', function (e) {
     if (notExcluded === true) { 
       var productData = {quantity: 0,id: pickupProduct};
       jqCR.post('/cart/change.js', productData, function(res, err) {console.log('Removed')})
       console.log('remove pickup parameters')
	   var attributes = {};
       attributes['Pickup_Information'] = '';
       attributes['Pickup_StoreID'] = '';
       attributes['_unixTimestamp'] = '';
       attributes['_formattedDate'] = '';

       attributes['Pickup_date'] = '';
       attributes['Pickup_time']  = '';
       attributes['Pickup_name']  = '';
       attributes['Pickup_phone']  = '';
       attributes['Pickup_extra1']  = '';
       attributes['Pickup_extra2']  = '';
       attributes['Pickup_extra3']  = '';
       attributes['Pickup_Store']  = '';
       attributes['pickup']  = '';
       
        var params = {
            type: 'POST',
            url: '/cart/update.js',
            data: {
                attributes: attributes
            },
            dataType: 'json',
            success: function() {
                console.log('Updated cart');               
            },
            error: function(XMLHttpRequest, textStatus) {
                console.log(XMLHttpRequest, textStatus);
            }
        };
        jqCR.ajax(params);
     }
})
// end show shipping button